import { createSlice } from "@reduxjs/toolkit";
import { PROJECT_FILE_FORMAT_VERSION } from "../../core/projectFileAPI";
import { RESOURCE_TYPES } from "../../core/resourceTypes";
export const projectSlice = createSlice({
    name: 'projectData',
    initialState: {
        project: {
            fileFormatVersion: PROJECT_FILE_FORMAT_VERSION,
            resources: {},
        },
        projectFilePath: '',
        resourceTypes: RESOURCE_TYPES,
    },
    reducers: {
        _createNewResource: (state, { payload }) => {
            const { id, resourceType } = payload;
            state.project.resources[id] = {
                id,
                typeID: resourceType.id,
                name: resourceType.initialName,
                data: resourceType.initialState,
            };
        },
        deleteResource: (state, { payload }) => {
            delete state.project.resources[payload];
        },
        openProject: (state, { payload }) => {
            state.project = payload.project;
            state.projectFilePath = payload.filePath;
        },
        renameResource: (state, { payload }) => {
            const { id, name } = payload;
            state.project.resources[id].name = name;
        },
        updateResource: (state, { payload }) => {
            const { id, ...rest } = payload;
            state.project.resources[id] = {
                ...rest,
                id,
            };
        },
    },
    selectors: {
        getResourceTypeByID: (state, id) => state.resourceTypes[id],
        getResourceTypes: (state) => state.resourceTypes,
        getProject: (state) => state.project,
        getProjectFilePath: (state) => state.projectFilePath,
    }
});
//# sourceMappingURL=projectSlice.js.map